import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface GoBackProps {
  to?: string;
}

const GoBack: React.FC<GoBackProps> = ({ to }) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const destination = to ?? `/application/${id}`;
  return (
    <Link
      to={destination}
      className="mb-6 inline-flex items-center gap-1 text-sm font-medium text-muted transition-colors hover:text-primary"
    >
      &larr; {t("goBack")}
    </Link>
  );
};

export default GoBack;
